import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { invoiceAPI } from 'redux/invoiceAPI';
import { FetchingState } from '@payer-admin-ui/components-v2/src/types/state';
import { AddManualInvoiceCreditUsageResponse } from '@payer-admin-ui/api/src/invoices/responses/AddManualInvoiceCreditUsageResponse';
import { CentsAmount } from '@payer-admin-ui/api/src/external/java/CentsAmount';
import i18n from 'i18next';
import { fetchInvoice } from '../invoicesGlobalState';
import { showSnackbar } from '../../../../redux/snackbar';

export const manualCreditUsage = createAsyncThunk<
  AddManualInvoiceCreditUsageResponse,
  { invoiceNumber: number; amount: CentsAmount }
>('invoices/actions/ManualCreditUsageModal/manualCreditUsage', async ({ invoiceNumber, amount }, { dispatch }) => {
  const response = await invoiceAPI.actions.manualCreditUsage({ invoiceNumber, amount });
  void dispatch(fetchInvoice({ invoiceNumber: response.invoice.invoiceNumber }));
  dispatch(
    showSnackbar(
      i18n.t('invoices.actions.manualCreditUsage.success', { invoiceNumber: response.invoice.invoiceNumber }),
      {
        severity: 'success',
      },
    ),
  );
  return response;
});

const initialState: FetchingState = {
  isFetching: false,
  success: undefined,
  error: null,
};

const manualCreditUsageModalSlice = createSlice({
  name: 'invoices/actions/ManualCreditUsageModal',
  initialState,
  reducers: {
    reset: _state => initialState,
  },
  extraReducers: builder => {
    builder.addCase(manualCreditUsage.pending, () => ({
      isFetching: true,
      success: undefined,
      error: null,
    }));
    builder.addCase(manualCreditUsage.fulfilled, () => ({
      isFetching: false,
      success: true,
      error: null,
    }));
    builder.addCase(manualCreditUsage.rejected, (_, { error }) => ({
      isFetching: false,
      success: false,
      error,
    }));
  },
});

export const {
  actions: { reset },
  reducer: manualCreditUsageModalReducer,
} = manualCreditUsageModalSlice;
